import React from 'react';
type Props = {
  scene: 'sky' | 'terminal' | 'road' | 'rainforest' | 'calm' | 'dusk' | 'sunset';
};

// Lightweight visual depth: static texture plus GPU-friendly drifting planes.
// GSAP owns their transform/opacity during the master journey timeline.
export function CinematicAtmosphere({
  scene
}: Props) {
  return <div className="pointer-events-none absolute inset-0 overflow-hidden" aria-hidden="true" data-id="element-109" data-mp="30fpinbypvymg">
      <div className={`atmosphere-wash atmosphere-wash--${scene} absolute inset-0`} data-id="element-110" data-mp="2mfy5tejxsoa1" />
      <div className="atmosphere-mist atmosphere-mist--far absolute -inset-[12%]" data-id="element-111" data-mp="2rgcg7390gab8" />
      <div className="atmosphere-mist atmosphere-mist--near absolute -inset-[18%]" data-id="element-112" data-mp="2cj1w55iaxw3w" />
      <div className="atmosphere-vignette absolute inset-0" data-id="element-113" data-mp="2hhwp309zh11q" />
      <div className="grain-overlay absolute inset-0 opacity-[0.055] mix-blend-overlay" data-id="element-114" data-mp="2hierken8obi3" />
    </div>;
}